import { Field } from 'formik';
import { Grid } from '@mui/material';
import MuiValidTextField from './input/MuiValidTextField';

const ClosedInformation = () => {
  return (
    <>
      <p className="mt-3">
        *Closed indicates that your business has shut down permanently or relocated somewhere
        outside of Utah County
      </p>
      <Grid
        id="closed-information"
        container
        sx={{ mt: { xs: '0.125rem' } }}
        rowSpacing={4}
        columnSpacing={{ xs: '0.125rem', sm: '0.25rem' }}
      >
        <Grid item xs={12} md={6}>
          <Field
            component={MuiValidTextField}
            label="What happened to the equipment?"
            name="equipGoneTo"
            variant="standard"
            inputProps={{ maxLength: 2000 }}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Field
            component={MuiValidTextField}
            label="Date Business Ceased Operating"
            name="dateBusClosed"
            type="Date"
            variant="standard"
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Field
            component={MuiValidTextField}
            label="Date Business License Cancelled"
            name="busLicCancelDate"
            type="Date"
            variant="standard"
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default ClosedInformation;
